"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetConfigure = resetConfigure;
exports.clearCache = clearCache;
exports.loadCache = loadCache;
exports.serializeCache = serializeCache;
exports.getFromCache = getFromCache;
exports.setCache = setCache;
exports.getCacheKey = getCacheKey;
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fetch = _interopRequireDefault(require("./../fetch"));

var _lruCache = _interopRequireDefault(require("lru-cache"));

var _staticCallback = _interopRequireDefault(require("./static-callback"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// This write was heavily inspired by https://github.com/simoneb/axios-hooks/blob/master/src/index.js
// If you are going to make changes or wanted to add tests, check the repo, they have tests there.
var cache;

function resetConfigure() {
  cache = new _lruCache["default"]();
}

resetConfigure();

function clearCache() {
  cache && cache.reset();
}

function loadCache(data) {
  cache.load(data);
}

function serializeCache() {
  return _regenerator["default"].async(function serializeCache$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", cache.dump());

        case 1:
        case "end":
          return _context.stop();
      }
    }
  });
}

function getFromCache(key) {
  return cache.get(key);
}

function setCache(key, data) {
  cache.set(key, data);
}
/**
 * Generates a cache key based on {@link JSON.stringify}.
 * If the config is of type {@link Object}, the keys are sorted recursively.
 *
 * @param config
 * @returns {string} a JSON representation of the config
 */


function getCacheKey(config) {
  return JSON.stringify(sortObjectKeys(config));
}

function sortObjectKeys(source) {
  if ((0, _typeof2["default"])(source) !== 'object') {
    return source;
  }

  var target = {};
  Object.keys(source).sort().forEach(function (key) {
    var value = source[key];
    target[key] = value && (0, _typeof2["default"])(value) === 'object' ? sortObjectKeys(value) : value;
  });
  return target;
}

function cacheAdapter(config) {
  var cacheKey, hit, response, responseForCache;
  return _regenerator["default"].async(function cacheAdapter$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          cacheKey = getCacheKey(config);
          hit = getFromCache(cacheKey);

          if (!hit) {
            _context2.next = 4;
            break;
          }

          return _context2.abrupt("return", hit);

        case 4:
          delete config.adapter; // i think this is specific for axios, but it can do no harm

          _context2.next = 7;
          return _regenerator["default"].awrap(fetchData(config));

        case 7:
          response = _context2.sent;
          responseForCache = (0, _toConsumableArray2["default"])(response); // delete responseForCache.config
          // delete responseForCache.request

          setCache(cacheKey, responseForCache);
          return _context2.abrupt("return", response);

        case 11:
        case "end":
          return _context2.stop();
      }
    }
  });
}

var actions = {
  FETCH_INIT: 'FETCH_INIT',
  FETCH_SUCCESS: 'FETCH_SUCCESS',
  FETCH_FAILURE: 'FETCH_FAILURE'
};

var fetchData = function fetchData(options) {
  var request, requestAsText, data;
  return _regenerator["default"].async(function fetchData$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return _regenerator["default"].awrap((0, _fetch["default"])(options.url, options));

        case 2:
          request = _context3.sent;
          _context3.next = 5;
          return _regenerator["default"].awrap(request.text());

        case 5:
          requestAsText = _context3.sent;
          data = requestAsText;

          if (options.returnType === 'json') {
            // Support 204 no content responses. The original request.json throwed an error when content is empty
            if (requestAsText.length > 0) {
              data = JSON.parse(requestAsText);
            } else if (request.status !== 200) {
              // When statuscode is not 200 and content is empty, use null as value instead of empty string
              data = null;
            }
          } else if (options.returnType === 'text') {
            // Nothing to do here since it is already text, just added to detect 'non-supported' return types
            // When statuscode is not 200 and content is empty, use null as value instead of empty string
            if (request.status !== 200 && requestAsText.length === 0) {
              data = null;
            }
          } else {
            // Or... Returntype was defined, but not supported yet, throw a message
            console.log("Returntype ".concat(options.returnType, " not supported, fallback to text"));
          }

          return _context3.abrupt("return", [request, data]);

        case 9:
        case "end":
          return _context3.stop();
      }
    }
  });
};

var dataFetchReducer = function dataFetchReducer(state, action) {
  switch (action.type) {
    case actions.FETCH_INIT:
      return _objectSpread({}, state, {
        isLoading: true,
        isSuccess: false,
        isError: false,
        status: undefined
      });

    case actions.FETCH_SUCCESS:
      return _objectSpread({}, state, {
        isLoading: false,
        isSuccess: true,
        isError: false,
        data: action.payload,
        status: action.status
      });

    case actions.FETCH_FAILURE:
      return _objectSpread({}, state, {
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
        status: action.status
      });

    default:
      throw new Error();
  }
};

function request(config, dispatch) {
  var response, _response, _response2, _request, data, modifySuccessPayload, modifyErrorPayload, isSuccess;

  return _regenerator["default"].async(function request$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          dispatch({
            type: actions.FETCH_INIT
          });

          if (config.method && config.method !== 'GET') {
            clearCache();
          }

          if (!config.adapter) {
            _context4.next = 9;
            break;
          }

          _context4.next = 6;
          return _regenerator["default"].awrap(config.adapter(config));

        case 6:
          response = _context4.sent;
          _context4.next = 12;
          break;

        case 9:
          _context4.next = 11;
          return _regenerator["default"].awrap(fetchData(config));

        case 11:
          response = _context4.sent;

        case 12:
          _response = response, _response2 = (0, _slicedToArray2["default"])(_response, 2), _request = _response2[0], data = _response2[1];

          modifySuccessPayload = config.modifySuccessPayload || function (data) {
            return data;
          };

          modifyErrorPayload = config.modifyErrorPayload || function (data) {
            return data;
          };

          if (_staticCallback["default"].onHandleStatus && !config.skipStatusCallback) {
            _staticCallback["default"].onHandleStatus(_request.status, data);
          } // Between 200 and 400 is a success request


          isSuccess = _request.status >= 200 && _request.status < 400;

          if (isSuccess) {
            dispatch({
              type: actions.FETCH_SUCCESS,
              payload: modifySuccessPayload(data),
              status: _request.status
            });
          } else {
            // 400 or more should be an error, but there can still be data
            dispatch({
              type: actions.FETCH_FAILURE,
              payload: modifyErrorPayload(data),
              status: _request.status
            });

            if (!config.dontShowErrorsInNotificationBar && data && data.message) {
              if (window) {
                if (_request.status !== 402) {
                  // Don't show for Payment error status 402
                  // Pass the message to the notification bar to show the error message
                  window.postMessage({
                    type: 'fetch_notification',
                    message: data.message
                  }, window.document.origin);
                }
              }
            }
          }

          _context4.next = 23;
          break;

        case 20:
          _context4.prev = 20;
          _context4.t0 = _context4["catch"](0);
          dispatch({
            type: actions.FETCH_FAILURE,
            payload: _context4.t0,
            status: 500
          });

        case 23:
        case "end":
          return _context4.stop();
      }
    }
  }, null, null, [[0, 20]]);
}

function executeRequestWithCache(config, dispatch) {
  return request(_objectSpread({}, config, {
    adapter: cacheAdapter
  }), dispatch);
}

function executeRequestWithoutCache(config, dispatch) {
  return request(config, dispatch);
}

var useDataApi = function useDataApi(initialConfig) {
  var _useState = (0, _react.useState)(initialConfig),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
      config = _useState2[0]; // check is everything is set correctly


  _propTypes["default"].checkPropTypes(useDataApiShape, initialConfig, 'options', 'hooks.useDataApi'); // get cache results from cache adapter on mount to prevent a first render without data


  var _ref = cache.get(JSON.stringify(initialConfig)) || [],
      _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
      configFromCache = _ref2[0],
      dataFromCache = _ref2[1];

  var cachedIsSuccess = false;
  var cachedIsError = false;

  if (configFromCache && configFromCache.status) {
    cachedIsSuccess = configFromCache.status >= 200 && configFromCache.status < 400;
    cachedIsError = !cachedIsSuccess;
  }

  var _useReducer = (0, _react.useReducer)(dataFetchReducer, {
    isLoading: !!initialConfig.url && !dataFromCache,
    isError: cachedIsError,
    isSuccess: cachedIsSuccess,
    data: initialConfig.initialData || dataFromCache,
    status: configFromCache && configFromCache.status
  }),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var doRequest = (0, _react.useCallback)(function (options) {
    if (options.useCache) {
      return executeRequestWithCache(_objectSpread({}, config, {}, options), dispatch);
    }

    return executeRequestWithoutCache(_objectSpread({}, config, {}, options), dispatch);
  }, []);
  (0, _react.useEffect)(function () {
    if (config && config.url && !dataFromCache) {
      // only do the request if the url is set. We should not always
      executeRequestWithCache(config, dispatch); // request(config, dispatch)
    }
  }, [request]);
  return [state, doRequest];
};

var useDataApiShape = {
  url: _propTypes["default"].string,
  skipCredentials: _propTypes["default"].bool,

  /** Skip the status callback for this individual request */
  skipStatusCallback: _propTypes["default"].bool,
  initialData: _propTypes["default"].object,
  modifySuccessPayload: _propTypes["default"].func,
  modifyErrorPayload: _propTypes["default"].func,
  returnType: _propTypes["default"].oneOf(['json', 'text']),
  dontShowErrorsInNotificationBar: _propTypes["default"].bool
};
var _default = useDataApi;
exports["default"] = _default;